import { render } from "./FeedBackCompanyComponent.vue?vue&type=template&id=1bb7a610&scoped=true&lang=html"
import script from "./FeedBackCompanyComponent.vue?vue&type=script&lang=js"
export * from "./FeedBackCompanyComponent.vue?vue&type=script&lang=js"

import "./FeedBackCompanyComponent.vue?vue&type=style&index=0&id=1bb7a610&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-1bb7a610"

export default script